import { RouteInfo } from './rm-sidebar.metadata';

export const ROUTES: RouteInfo[] = [
    // {
    //   path: '',
    //   title: 'Personal',
    //   icon: 'mdi mdi-dots-horizontal',
    //   class: 'nav-small-cap',
    //   extralink: true,
    //   submenu: []
    // },
    {
      path: '/rm/rm-dashboard',
      title: 'Dashboard',
      icon: 'icon-Dashboard',
      class: '',
      extralink: false,
      submenu: []
    },
    {
      path: '/rm/customer-onboarding',
      title: 'Customer-Onboarding',
      icon: 'icon-Bar-Chart',
      class: '',
      extralink: false,
      submenu: []
    },
  ];
